=<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off" style="width: 100%;">
                        <div class="row">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">

                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0" style="padding-top: 0px !important;">

                                        <div class="row">


                                            <div class="col-xl-4 col-xs-12 col-md-6 col-lg-4">
                                                <div class="submit-field">
                                                    <h5>Nome:</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.nome">
                                                </div>
                                            </div>

                                            <div class="col-xl-12 clearfix"></div>

                                            <div class="col-xl-12 col-md-12 col-lg-12 margin-top-10">
                                                <div class="submit-field">
                                                    <h5>Usuários que pertencem a essa área ({{form.usuarios.length}}):</h5>
                                                    <select class="selectpicker" data-size="10" multiple="" data-live-search="true" data-live-search-placeholder="Pesquise aqui.."  data-allow-clear="true" title="Selecione aqui.." v-model="form.usuarios">
                                                        <option default="" disabled value="">Selecione..</option>                                                                   
                                                        <option v-for="(item, index) in usuarios.itens" :key="'usuario-' + item.cod" :value="item.cod">{{item.nome}}</option>                                                              
                                                    </select>
                                                </div>
                                            </div>

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-30 margin-top-15">
                                                <button type="submit" class="button green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="las la-save"></i>
                                                    Salvar área
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarAreas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar,
        'AvatarCropper':            AvatarCropper
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "usuarios": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "usuarios":         []
            }            
        }
    },
    watch: {
       
    },
    methods: {     
        getUsuarios: function() {
            var self        = this;
            console.log("getUsuarios()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "!contratante"
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUsuarios() response", response);

                    // response.data.result.itens = response.data.result.itens.map(function(item) {
                    //     return {
                    //         "id":   item.id,
                    //         "cod":  item.cod,
                    //         "nome": item.nome
                    //     }
                    // });

                    self.usuarios       = response.data.result; 
                    // loading.hide();
                    console.log("setou usuarios", self.usuarios)
                    self.$forceUpdate();
                    resolve(response.data.result);

                    setTimeout(function() {
                        $(".selectpicker").selectpicker("refresh");
                    }, 500);

                })
                .catch(error => {
                    console.log("getUsuarios() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },           
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/areas.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/areas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            var self = this;
            console.log("init()")
            if (self.$route.name == "EditarAreas") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                self.get();
            } else {
                loading.hide();
            }
            self.getUsuarios();            
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);
        self.init();
    },
    activated: function() {
        var self = this;
        console.log("activated", self);
        self.init();
    },    
    mounted: function() {
        var self = this;
        console.log("mounted", self);
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarAreas.vue